import { FC } from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const MxLogo: FC<IconBaseProps> = (props) => (
  <IconBase
    {...props}
    width="52px"
    height="52px"
    viewBox="0 0 512 512"
    role="presentation"
    data-testid="mxlogo"
  >
    <g>
      <g>
        <g>
          <g>
            <path
              d="M263.94,324.13l19.74-25.39c0.17-0.17,0.17-0.5,0.17-0.66l-17.42-120.12c0-0.5-0.5-0.83-1-0.83h-22.73
					c-0.33,0-0.66,0.17-0.83,0.5l-54.26,110.5c-0.33,0.66-1.33,0.66-1.66,0l-54.75-110.5c-0.17-0.33-0.5-0.5-0.83-0.5h-22.9
					c-0.5,0-0.83,0.33-1,0.83l-21.9,150.82c-0.17,0.5,0.33,1,1,1h26.55c0.5,0,0.83-0.33,1-0.83l13.27-96.73
					c0.17-1,1.33-1.16,1.83-0.33l48.28,97.39c0.17,0.33,0.5,0.5,0.83,0.5h18.75c0.33,0,0.66-0.17,0.83-0.5l47.62-96.07
					c0.5-0.83,1.66-0.66,1.83,0.33l12.94,93.74c0.17,0.83,1.16,1.16,1.66,0.5L263.94,324.13z"
            />
            <path
              d="M425.55,177.12H392.2c-0.33,0-0.5,0.17-0.83,0.33l-39.99,52.43c-0.33,0.5-1.16,0.5-1.49,0l-40.15-52.43
					c-0.17-0.17-0.5-0.33-0.83-0.33h-33.35c-0.83,0-1.16,1-0.83,1.49l57.41,74.33c0.33,0.33,0.33,0.83,0,1.16l-57.41,74.33
					c-0.5,0.66,0,1.49,0.83,1.49h33.35c0.33,0,0.5-0.17,0.83-0.33l40.15-52.43c0.33-0.5,1.16-0.5,1.49,0l40.15,52.43
					c0.17,0.17,0.5,0.33,0.83,0.33h33.35c0.83,0,1.16-1,0.83-1.49l-57.41-74.33c-0.33-0.33-0.33-0.83,0-1.16l57.41-74.33
					C426.71,177.95,426.38,177.12,425.55,177.12z"
            />
          </g>
        </g>
        <g>
          <path
            d="M439.07,329.77c-4.05,0-7.33-3.29-7.33-7.33c0-4.08,3.29-7.33,7.33-7.33c4.08,0,7.33,3.25,7.33,7.33
				C446.4,326.48,443.15,329.77,439.07,329.77z M439.07,316.32c-3.39,0-6.12,2.7-6.12,6.12c0,3.36,2.73,6.12,6.12,6.12
				c3.39,0,6.12-2.77,6.12-6.12C445.19,319.01,442.46,316.32,439.07,316.32z M441.04,326.66l-2.18-3.32h-1.35v3.32h-1.28v-8.4h3.42
				c1.42,0,2.84,1,2.84,2.56c0,1.87-1.66,2.49-2.14,2.49l2.25,3.35H441.04z M439.66,319.32h-2.15v2.91h2.15
				c0.73,0,1.52-0.55,1.52-1.42C441.18,319.88,440.39,319.32,439.66,319.32z"
          />
        </g>
      </g>
    </g>
  </IconBase>
);
